<template>
  <div>
    <Main
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @openDetailDialog="openDetailDialog"
      @batchDel="submitDel"
      ref="tableMain"
    >
      <Header
        ref="tableHeader"
        slot="header"
        :disabled="disabled"
        @openDetailDialog="openDetailDialog"
        @batchDel="batchDel"
      />
    </Main>
    <GoodsSpecDetailDialog
      :changeOrderGoodsCode="param.changeOrderGoodsCode"
      :changeOrderCode="param.changeOrderCode"
      :orderGoodsCode="param.orderGoodsCode"
      :orderCode="param.orderCode"
      :disabled="goodsSpecDetailDialogParams.disabled"
      :visible="goodsSpecDetailDialogParams.visible"
      :title="goodsSpecDetailDialogParams.title"
      :changeOrderGoodsSpecCode="goodsSpecDetailDialogParams.code"
      @reload="getData()"
      @close="() => (goodsSpecDetailDialogParams.visible = false)"
      ref="goodsDetailDialog"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import GoodsSpecDetailDialog from '../components/detail/dialog.vue'
export default {
  components: { Main, Header, GoodsSpecDetailDialog },
  props: {
    param: { type: Object, default: () => {} },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      goodsSpecDetailDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.param.orderGoodsCode) return
      this.loading = true
      this.$api
        .changeGoodsSpecListApi({
          orderGoodsCode: this.param.orderGoodsCode,
          changeOrderCode: this.param.changeOrderCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetailDialog({ type, code = '' }) {
      const types = {
        add:
          this.$l('INDEX.dialog_title_order_goods_spec_add_info') ||
          '添加订单产品规格信息',
        edit:
          this.$l('INDEX.dialog_title_order_goods_spec_edit_info') ||
          '编辑订单产品规格信息',
        detail:
          this.$l('INDEX.dialog_title_order_goods_spec_detail_info') ||
          '订单产品信息规格详情',
      }
      this.goodsSpecDetailDialogParams = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
      }
    },
    batchDel() {
      const listCode = this.$refs.tableMain.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .changeOrderGoodsSpecDelApi({
            listCode,
            changeOrderCode: this.param.changeOrderCode,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.getData()
          })
      })
    },
  },
}
</script>
